import { ICON_BASE_PATH } from "@/app/utils/config";
import type { ReactNode } from "react";

interface DialogLgProps {
  open: boolean;
  close: () => void;
  children: ReactNode;
  title?: ReactNode;
  primaryBtnLabel?: string;
  secondaryBtnLabel?: string;
  primaryBtn?: () => void;
  secondaryBtn?: () => void;
}

const DialogMini: React.FC<DialogLgProps> = ({
  open,
  close,
  children,
  title,
  primaryBtnLabel,
  secondaryBtnLabel,
  primaryBtn,
  secondaryBtn,
}) => {
  if (!open) return null;

  return (
    <div className="gx-dialog-mini-overlay">
      <div className="gx-dialog-mini">
        <div className="gx-dialog-mini-header">
          {title ?? <span />}
          <button
            type="button"
            className="gx-dialog-close-button"
            onClick={close}
          >
            <img
              className="gx-icon-primary"
              src={`${ICON_BASE_PATH}close.svg`}
              alt="Close"
            />
          </button>
        </div>

        <div className="gx-dialog-mini-content">{children}</div>

        <div className="gx-dialog-mini-footer">
          <button
            type="button"
            className="gx-dialog-mini-secondary-btn"
            onClick={secondaryBtn}
          >
            <span className="gx-p16-b"> {secondaryBtnLabel}</span>
          </button>
          <button
            type="button"
            className="gx-dialog-mini-primary-btn"
            onClick={primaryBtn}
          >
            <span className="gx-p16-b">{primaryBtnLabel}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DialogMini;
